// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { reduxForm } from 'redux-form'
import { radioDatabaseSearchValidate } from 'validators/databaseSearches'

import {
  AdvancedSearchWrapper,
  Pagination,
} from '../common'

import {
  AdvancedSearch,
  BasicSearch,
} from './components'

const Form = ({ change, error, exportResults, form, handleSubmit, hasResults }) => (
  <form
    id={form}
    className={'padding-left-1 padding-right-1 heading-font'}
    onSubmit={handleSubmit}>
    { error && <p id={`${form}-error`} className={'width-100 bg-red margin-top-half'}>{error}</p>}
    <BasicSearch
      change={change}
      exportResults={exportResults}
      idRoot={`${form}-`}
      hasResults={hasResults}
      sourceForm={form} />
    <AdvancedSearchWrapper
      AdvancedSearch={AdvancedSearch}
      change={change}
      idRoot={`${form}-`}
      sourceForm={form}
      staticLabel={'Advanced Search'} />
    <Pagination
      idRoot={`${form}-`}
      sourceForm={form} />
  </form>
)

Form.propTypes = {
  change: func.isRequired,
  exportResults: func.isRequired,
  form: string.isRequired,
  handleSubmit: func.isRequired,
  hasResults: bool.isRequired,
  error: string,
}

const { asyncValidate, validate } = radioDatabaseSearchValidate

export default reduxForm({
  asyncBlurFields: [
    'companyName',
  ],
  asyncValidate,
  destroyOnUnmount: false, // allows for previous form values to persist
  validate,
})(Form)
